module.exports = __webpack_public_path__ + "media/images/inhib-logo-b7092ae57e78c1feee8e3c08d56d8d1a.svg";